import { ReactElement } from 'react';
import { Form, Input, DatePicker, TimePicker, Button, Space, Select } from 'antd';
import { FormInstance } from 'antd/es/form';
import { Dayjs } from 'dayjs';
import { ButtonRow } from './ButtonRow.style';

interface FormValues {
  title: string;
  advisorId: number;
  customerId: number;
  meetingDate: Dayjs;
  meetingTime: Dayjs;
}

interface Props {
  form: FormInstance<FormValues>;
  advisorOptions: { value: number; label: string }[];
  customerOptions: { value: number; label: string }[];
  onSave: () => void;
  onCancel: () => void;
  loading?: boolean;
}

const RecordingInfoForm = ({
  form,
  advisorOptions,
  customerOptions,
  onSave,
  onCancel,
  loading = false,
}: Props): ReactElement => {
  return (
    <Form form={form} layout='vertical' size='small'>
      <Form.Item label='タイトル' name='title' rules={[{ required: true, message: 'タイトルを入力してください' }]}>
        <Input disabled={loading} />
      </Form.Item>
      <Form.Item
        label='営業担当者'
        name='advisorId'
        rules={[{ required: true, message: '営業担当者を選択してください' }]}
      >
        <Select
          options={advisorOptions}
          showSearch
          filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          disabled={loading}
        />
      </Form.Item>
      <Form.Item label='顧客名' name='customerId' rules={[{ required: true, message: '顧客を選択してください' }]}>
        <Select
          options={customerOptions}
          showSearch
          filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          disabled={loading}
        />
      </Form.Item>
      <Space>
        <Form.Item label='面談日' name='meetingDate' rules={[{ required: true, message: '面談日を選択してください' }]}>
          <DatePicker disabled={loading} />
        </Form.Item>
        <Form.Item
          label='面談時間'
          name='meetingTime'
          rules={[{ required: true, message: '面談時間を選択してください' }]}
        >
          <TimePicker format='HH:mm:ss' disabled={loading} />
        </Form.Item>
      </Space>
      <ButtonRow>
        <Button type='primary' onClick={onSave} loading={loading}>
          保存
        </Button>
        <Button onClick={onCancel} disabled={loading}>
          キャンセル
        </Button>
      </ButtonRow>
    </Form>
  );
};

export default RecordingInfoForm;
